// GovWellRequestHeaders is duplicated on the BE
export enum GovWellRequestHeaders {
  Platform = 'X-Govwell-Platform',
  TimeZone = 'X-Govwell-Time-Zone',
  FlagOverrides = 'X-Govwell-Flag-Overrides',
}
